import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import { postServerDataWithPath } from "../../../action/common_action";
import {
  axiosInstnace as Axios,
  axiosInstnace,
  calculateAmountAndTax,
} from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import useModel from "../common/useModel";
import ApproveModel from "../common/approveModel";
import RejectModel from "../common/rejectModel";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import ExcelPopup from "./ExcelPopup";
import UploadContract from "./UploadContract";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import Dropdown from "react-dropdown";
import { CommonModelImpl } from "../../admin/common/CommonModel";
import EditToOrder from "./EditToOrder";
import { ChangeEndDate } from "./ChangeEndDate";
import ViewStationsModal from "../audioadminmanagment/ViewStationsModal";
import LinkPayment from "./LinkPayment";

const Index = (props) => {
  const [audioStateArr] = useState([
    "New",
    "Audio Approved",
    "RO Approved",
    "Production Sale",
  ]);
  const [audioStateArray] = useState(["New", "Audio Approved"]);
  const [customendDate, handleCustomEndDate] = useState(undefined);
  const [showCustomEndDatePopup, handleCustomEndDatePopup] = useState(false);
  const [showstationlist, handleshowstationlist] = useState(false);
  const [currentStations, handleCurrentStations] = useState([]);


  const [roStateArray] = useState(["Ro Approved", "RO Booked"]);
  const [productionStateArray] = useState([
    "Production Sale",
    "Invoice Booked",
  ]);
  const [showconfirmpaymentcapture, handleshowconfirmpaymentcapture] = useState(
    false
  );
  const [campaigns, handleCampaignList] = useState([]);
  const { isShowing, toggle } = useModel();
  const { isRejectShowing, rejectToggle } = useModel();
  const [user_email, handleUserEmail] = useState("");
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [packagetype, handlePackagetype] = useState(undefined);

  //vjvjj
  const [campaignstatustype, handleCampaignstatustype] = useState(undefined);
  const [rostatustype, handleRostatustype] = useState(undefined);

  const [razorpay, handleRazorpay] = useState(undefined);
  const searchRazorpay = useRef(undefined);
  const [paymentArr] = useState(["Pending", "Link Payment"]);

  const [station, handleStation] = useState(undefined);
  const [email, handleEmail] = useState(undefined);
  const [audio, handleAudio] = useState("");
  const [campaignId, handleCampaignId] = useState("");
  const [searchName, handleSearchName] = useState(undefined);
  const [searchId, handleSearchId] = useState(undefined);
  const [fileType, handleFileType] = useState(undefined);
  const [status, handleStatus] = useState(undefined);
  const [statusStages, handleStatusStages] = useState(undefined);
  const [enableSideBar, handleEnableSideBar] = useState("admin");
  const [paymentId, handlePaymentId] = useState(undefined);

  //vj
  // const [searchStation, handleSearchStation] = useState(undefined);
  const [skip, handleSkip] = useState(0);
  const [updatePaymentId, handleupdatePaymentId] = useState(false);

  const [count, handleCount] = useState(0);
  const [showExcelPopup, setShowHideExcelPopup] = useState(false);
  const [showUploadContract, setShowHideUploadContract] = useState(false);
  const [showTrafficOrder, setShowshowTrafficOrder] = useState(false);
  const campaignName = useRef(undefined);
  const userEmail = useRef(undefined);
  const searchStation = useRef(station);
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  const [currentCampaign, handleCurrentCampaign] = useState(undefined);
  const [updateObj, handleUpdateObj] = useState(undefined);
  const [clusterdata, handleClusterData] = useState([]);
  const [clusterdatanametype, handleClusterDataNameType] = useState(undefined);
  const [msg, handlemsg] = useState(
    "Alert! Please confirm that the payment against this campaign has captured in razorpay portal"
  );
  const [statusvalue, handleStatusValue] = useState("");
  const [selectedCampaign, handleSelectedCampaign] = useState("");
  const [selectedCustomerDetails, setselectedCustomerDetails] = useState("");
  const [searchCampaignId, handleSearchCampaignId] = useState(undefined);
  // const packagetype = useRef(undefined);

  useEffect(() => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
    getClusterData(0);
  }, []);

  const hideshowstations = (e) => {
    handleshowstationlist(!showstationlist);
  };

  const getClusterData = async (skip, name) => {
    handleSkip(skip);
    try {
      const response = await Axios.get(`${endPoints.getClusters}`, {
        params: {
          type: "all",
          withoutTradepartnerList: true
        },
      });
      let result = response.data.data.allData;
      result = result
        .map((e) => {
          return e.name;
        })
        .sort();
      if (result) {
        handleClusterData(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const generateTrafficOrder = () => {
    handleCustomEndDatePopup(false);
    showHideTrafficOrder();
  };
  
  const removePaymentId = () => {
    handleupdatePaymentId(!updatePaymentId);
    handlePaymentId(undefined);
  };

  const callCurrentPage= ()=>{
    debugger
    getCampaignlist(skip, undefined, undefined, "Pending", false);
  }

  //Fetching the campaign list
  const getCampaignlist = async (skip, name, id, status, reset) => {
    var paramsConstrct;
    if (!reset) {
      if (adminInfo && adminInfo.role && adminInfo.role === "stationAdmin") {
        paramsConstrct = {
          skip,
          name: campaignName.current.value,
          userEmail: userEmail.current.value,
          station: adminInfo.station ? adminInfo.station : undefined,
          _id: id,
          startDate: startDate,
          endDate: endDate,
          packageType:
           packagetype,
          campaignstatustype: campaignstatustype,
        };
      } else if (
        adminInfo &&
        adminInfo.role &&
        (adminInfo.role === "salesUser" || adminInfo.role === "auditAdmin")
      ) {
        paramsConstrct = {
          skip,
          name: campaignName.current.value,
          userEmail: userEmail.current.value,
          station: searchStation.current.value,
          cluster: adminInfo.cluster ? adminInfo.cluster : "",
          selectedCluster: clusterdatanametype ? clusterdatanametype : "",
          _id: id,
          sallerId: adminInfo.email,
          startDate: startDate,
          endDate: endDate,
          packageType:
           packagetype,
          campaignstatustype: campaignstatustype,
        };
      } else if (
        adminInfo &&
        adminInfo.role &&
        adminInfo.role === "trafficAdmin"
      ) {
        paramsConstrct = {
          skip,
          name: campaignName.current.value,
          userEmail: userEmail.current.value,
          station: searchStation.current.value,
          cluster: adminInfo.cluster ? adminInfo.cluster : "",
          selectedCluster: clusterdatanametype ? clusterdatanametype : "",
          _id: id,
          status: "RO Approved",
          statusList: [
            "RO Approved",
            "RO Booked",
            "Production Sale",
            "Invoice Booked",
          ],
          startDate: startDate,
          endDate: endDate,
          packageType:
           packagetype,
          rostatustype: rostatustype,
        };
      } else if (
        adminInfo &&
        adminInfo.role &&
        adminInfo.role === "campaignAdmin"
      ) {
        paramsConstrct = {
          skip,
          name: campaignName.current.value,
          userEmail: userEmail.current.value,
          station: searchStation.current.value,
          cluster: adminInfo.cluster ? adminInfo.cluster : "",
          selectedCluster: clusterdatanametype ? clusterdatanametype : "",
          payId: searchRazorpay.current.value,
          _id: id,
          startDate: startDate,
          endDate: endDate,
          packageType:
           packagetype,
          campaignstatustype: campaignstatustype,
        };
      } else {
        
        paramsConstrct = {
          skip,
          name: campaignName.current.value,
          userEmail: userEmail.current.value,
          station: searchStation.current.value,
          cluster: adminInfo.cluster ? adminInfo.cluster : "",
          selectedCluster: clusterdatanametype ? clusterdatanametype : "",
          payId: searchRazorpay.current.value,
          _id: id,
          startDate: startDate,
          endDate: endDate,
          packageType:
           packagetype,
          campaignstatustype: campaignstatustype,
        };
      }
    } else {
      paramsConstrct = {
        skip: 0,
        name: undefined,
        userEmail: undefined,
        station: undefined,
        razorpay: undefined,
        id: undefined,
        startDate: undefined,
        endDate: undefined,
        packageType: undefined,
        campaignstatustype: undefined,
      };
    }

    handleSkip(skip);
    try {
      const data = await Axios.get(endPoints.getAllCampaign, {
        params: paramsConstrct,
      });
      let result = data.data.data.data;
      if (result) {
        result = result.map((campaign) => {
          return calculateAmountAndTax(campaign, true);
        });
        // if(packagetype == "Production Sale"){
        //   result = result.filter((e)=>{
        //     return e.startDate == null
        //   })
        // }else{
        //   result = result.filter((e)=>{
        //     return e.startDate != null
        //   })
        // }

        handleCampaignList(result);
        handleSearchName(name);
        handleRazorpay(razorpay);
        handleSearchId(id);
        handleCount(data.data.data.count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Searching the campaign
  const getSearch = async (e, field) => {
    if (e.target.value.length === 24) {
      getCampaignlist(0, undefined, e.target.value, "Pending", false);
    } else {
      getCampaignlist(0, undefined, undefined, "Pending", false);
    }
  };

  const linkpayment = async (event, campaign) => {
    let { value } = event.target;
    
    if (value === "Pending") {
      alert(`Campaign Can't be moved to New state`);
      return;
    }
    if (value == "Link Payment") {
      handleupdatePaymentId(true);
      console.log("asdsadsadsadsadsadasd", updatePaymentId);
      handleCampaignId(campaign._id);
      return;
    }
    getCampaignlist(skip, undefined, undefined, "Pending", false);
  };
  //Submit Search Fields
  const handleChangeLimit = (name, event) => {
    console.log("Name", name.current.value);
    console.log(campaignName);
  };
  const showHidePaymentConfirmationPopup = () => {
    handleshowconfirmpaymentcapture(!showconfirmpaymentcapture);
  };
  const closecustomenddatepopup = () => {
    handleCustomEndDatePopup(!showCustomEndDatePopup);
  };
  const setStatusAfterPaymentConfirmation = async () => {
    handleshowconfirmpaymentcapture(!showconfirmpaymentcapture);
    let campaign = selectedCampaign;
    let value = statusvalue;
    let data = {
      _id: campaign._id,
      updateObj: {
        status: value == "New" ? "Pending" : value,
      },
    };
    data.updateObj.statusStages = campaign.statusStages
      ? JSON.parse(JSON.stringify(campaign.statusStages))
      : [];
    data.updateObj.statusStages.push(data.updateObj.status);
    if (value == "Audio Approved" || value == "RO Approved") {
      data.userEmail = campaign.userEmail;
      if (
        (campaign.bigFmAudio == "false" &&
          campaign.audioStatus.includes("Reject")) ||
        (campaign.bigFmAudio == "true" &&
          !campaign.audioStatus.includes("Approve") &&
          value === "Audio Approved")
      ) {
        alert(
          `Campaign status cannot be changed as "Audio Approved" since customer has not approved the audio`
        );
        return;
      } else if (value === "Audio Approved") {
        handleStatus(value);
        handleStatusStages(data.updateObj.statusStages);
        handleFileType("Traffic Order");
        handleCampaignId(campaign._id);
        handleCurrentCampaign(campaign);
        selectedCustomerDetails({
          clientName: campaign.userDetails[0].name,
          clientStation: campaign.userDetails[0].city,
          clientAddress: "",
          clientBrand: campaign.userDetails[0].company,
        });
        handleCustomEndDate(moment(campaign.startDate).add(campaign.days -1,  'days').valueOf())
        handleCustomEndDatePopup(true);
        // showHideUploadContract();
        return;
      }
    }

    let cutoffDate;
    if (
      moment(campaign.startDate)
        .subtract(1, "days")
        .get("day") == 0
    ) {
      cutoffDate = 3;
    } else if (
      moment(campaign.startDate)
        .subtract(1, "days")
        .get("day") == 6
    ) {
      cutoffDate = 2;
    } else {
      cutoffDate = 1;
    }
    let campaignStartDate = moment(campaign.startDate)
      .subtract(cutoffDate, "days")
      .add(15, "hours")
      .valueOf();
    let limitStartDate = moment().valueOf();
    if (value === "Production Sale") {
      if (campaign.bigFmAudio == "false") {
        alert(
          "Production Sale will be available only for BIGFM Audio Campaigns"
        );
        return;
      } else if (campaignStartDate > limitStartDate) {
        alert(
          "Cut off Limit not reached, the campaign starts only on " +
            moment(campaignStartDate).format("DD/MM/YYYY hh:mm A")
        );
      } else if (campaign.crossRefId) {
        alert("Campaign Already marked as Production Sale");
      } else if (campaign.status !== "Audio Approved") {
        alert("Production Sale can't be done before Audio Approval");
      } else {
        handleStatus(value);
        handleStatusStages(data.updateObj.statusStages);
        handleFileType("Revised Traffic Order");
        handleCampaignId(campaign._id);
        handleCurrentCampaign(campaign);
        handleUpdateObj(data);
        setselectedCustomerDetails({
          clientName: campaign.userDetails[0].name,
          clientStation: campaign.userDetails[0].city,
          clientAddress: "",
          clientBrand: campaign.userDetails[0].company,
        });
        handleCustomEndDate(moment(campaign.startDate).add(campaign.days -1,  'days').valueOf())
        handleCustomEndDatePopup(true);
        // showHideUploadContract();
        return;
      }
    } else if (
      (campaign.pendingAmount > 0 || campaign.status != "Audio Approved") &&
      value === "RO Approved"
    ) {
      alert(
        "RO Approval can be done after the payment is completed and Audio Approved"
      );
    } else if (value === "RO Approved" || value === "Production Sale") {
      let invoices = await axiosInstnace.get(endPoints.checkpaymentstatus, {
        params: { campaignId: campaign._id },
      });
      invoices = invoices.data.data.map((e) => {
        return e.status;
      });
      invoices = [...new Set(Array.from(invoices))];

      if (
        invoices.length == 0 ||
        invoices.length > 1 ||
        invoices[0] === "Authorized"
      ) {
        alert("Payment is not captured in razor pay");
      } else {
        await props.updateCampaign(
          endPoints.updateCampaign,
          data,
          "/admin/campaign"
        );
        getCampaignlist(skip, undefined, undefined, "Pending", false);
      }
    } else {
      await props.updateCampaign(
        endPoints.updateCampaign,
        data,
        "/admin/campaign"
      );
      getCampaignlist(skip, undefined, undefined, "Pending", false);
    }
  };

  //Set audio status
  const setAudioStatus = async (event, campaign) => {
    let { value } = event.target;
    if (!campaign.startDate && !["Archive", "Un Archive"].includes(value)) {
      alert(
        `${value} can't be done because campaign doesn't have a valid start date`
      );
      return;
    }
    if (value === "New") {
      alert(`Campaign Can't be moved to New state`);
      return;
    }
    if (["Production Sale", "RO Approved"].includes(value.trim())) {
      handleshowconfirmpaymentcapture(true);
      handleStatusValue(value);
      handleSelectedCampaign(campaign);
      return;
    }
    let data = {
      _id: campaign._id,
      updateObj: {
        status: value == "New" ? "Pending" : value,
      },
    };
    data.updateObj.statusStages = campaign.statusStages
      ? JSON.parse(JSON.stringify(campaign.statusStages))
      : [];
    data.updateObj.statusStages.push(data.updateObj.status);
    if (value == "Audio Approved" || value == "RO Approved") {
      data.userEmail = campaign.userEmail;
      if (
        (campaign.bigFmAudio == "false" &&
          campaign.audioStatus.includes("Reject")) ||
        (campaign.bigFmAudio == "true" &&
          !campaign.audioStatus.includes("Approve") &&
          value === "Audio Approved")
      ) {
        alert(
          `Campaign status cannot be changed as "Audio Approved" since customer has not approved the audio`
        );
        return;
      } else if (value === "Audio Approved") {
        handleStatus(value);
        handleStatusStages(data.updateObj.statusStages);
        handleFileType("Traffic Order");
        handleCampaignId(campaign._id);
        handleCurrentCampaign(campaign);
        setselectedCustomerDetails({
          clientName: campaign.userDetails[0].name,
          clientStation: campaign.userDetails[0].city,
          clientAddress: "",
          clientBrand: campaign.userDetails[0].company,
        });
        handleCustomEndDate(moment(campaign.startDate).add(campaign.days -1,  'days').valueOf())
        handleCustomEndDatePopup(true);
        // showHideUploadContract();
        return;
      }
    }
    let cutoffDate;
    if (
      moment(campaign.startDate)
        .subtract(1, "days")
        .get("day") == 0
    ) {
      cutoffDate = 3;
    } else if (
      moment(campaign.startDate)
        .subtract(1, "days")
        .get("day") == 6
    ) {
      cutoffDate = 2;
    } else {
      cutoffDate = 1;
    }
    let campaignStartDate = moment(campaign.startDate)
      .subtract(cutoffDate, "days")
      .add(15, "hours")
      .valueOf();
    let limitStartDate = moment().valueOf();
    if (value === "Production Sale") {
      if (campaign.bigFmAudio == "false") {
        alert(
          "Production Sale will be available only for BIGFM Audio Campaigns"
        );
        return;
      } else if (campaignStartDate > limitStartDate) {
        alert(
          "Cut off Limit not reached, the campaign starts only on " +
            moment(campaignStartDate).format("DD/MM/YYYY hh:mm A")
        );
      } else if (campaign.crossRefId) {
        alert("Campaign Already marked as Production Sale");
      } else if (campaign.status !== "Audio Approved") {
        alert("Production Sale can't be done before Audio Approval");
      } else {
        handleStatus(value);
        handleStatusStages(data.updateObj.statusStages);
        handleFileType("Revised Traffic Order");
        handleCampaignId(campaign._id);
        handleCurrentCampaign(campaign);
        handleUpdateObj(data);
        setselectedCustomerDetails({
          clientName: campaign.userDetails[0].name,
          clientStation: campaign.userDetails[0].city,
          clientAddress: "",
          clientBrand: campaign.userDetails[0].company,
        });
        handleCustomEndDate(moment(campaign.startDate).add(campaign.days -1,  'days').valueOf())
        handleCustomEndDatePopup(true);
        // showHideUploadContract();
        return;
      }
    } else if (
      (campaign.pendingAmount > 0 || campaign.status != "Audio Approved") &&
      value === "RO Approved"
    ) {
      alert(
        "RO Approval can be done after the payment is completed and Audio Approved"
      );
    } else {
      await props.updateCampaign(
        endPoints.updateCampaign,
        data,
        "/admin/campaign"
      );
      getCampaignlist(skip, undefined, undefined, "Pending", false);
    }
  };

  //Set audio status
  const setRoStatus = async (event, campaign) => {
    let { value } = event.target;
    let data = {
      _id: campaign._id,
      updateObj: {
        status: value == "New" ? "Pending" : value,
      },
    };
    if (value == "RO Approved" || value == "RO Booked") {
      data.userEmail = campaign.userEmail;
    }
    if (value == "RO Booked" || value === "Invoice Booked") {
      handleStatus(value);
      handleFileType("Contract");
      handleCampaignId(campaign._id);
      handleCustomEndDate(moment(campaign.startDate).add(campaign.days -1,  'days').valueOf())
      showHideUploadContract();
    }
  };

  const openPopup = (Campaign, e) => {
    handleUserEmail(Campaign.userEmail ? Campaign.userEmail : "");
    handleCampaignId(Campaign._id ? Campaign._id : "");

    // //vj
    // handleStation ( campaign.station ?  campaign.station:''  );
    // handleUserName  ( campaign.userName  ?   campaign.userName  :''  );
    // handleUserMobile ( campaign.userMobile  ? campaign.userMobile  :''  );

    toggle();
  };

  //Show rejected popup
  const openRejectPopup = (Campaign, e) => {
    let { bigFmAudio } = Campaign;
    if (bigFmAudio == "true") {
      return;
    }
    handleUserEmail(Campaign.userEmail ? Campaign.userEmail : "");
    handleCampaignId(Campaign._id ? Campaign._id : "");
    handleStation(campaign.station ? campaign.station : "");
    rejectToggle();
  };

  const showHideExcelPopup = () => {
    setShowHideExcelPopup(!showExcelPopup);
  };

  const showHideUploadContract = () => {
    setShowHideUploadContract(!showUploadContract);
  };

  const showChangeEndDate = () => {
    showHideTrafficOrder()
    handleCustomEndDatePopup(!showCustomEndDatePopup)
  };
  const showHideTrafficOrder = () => {
    setShowshowTrafficOrder(!showTrafficOrder);
  };

  const uploadContact = (values) => {
    console.log(values);
  };

  const callSearch = () => {
    getCampaignlist(0, undefined, searchCampaignId, "Pending", false);
  };

  const clearSearch = () => {
    window.location.reload(true);
    // this.userEmail.current.value = "";

    //   const campaignName = undefined;
    //   const userEmail = undefined;
    //   setStartDate(undefined);
    //   setEndDate(undefined);
    //   handleEmail(undefined);
    //   handleRazorpay(undefined);
    //   handleSearchName(undefined);
    //   handleStation(undefined)
    //   // handleCampaignList([]);
    //   handlePackagetype(undefined);
    //   handleCampaignstatustype(undefined);
    //   handleRostatustype(undefined);

    //   getCampaignlist(0, undefined, undefined, "Pending",true);
  };

  const options = ["one", "two", "three", "four"];

  //Return the table for campaign
  return (
    <div>
      <ApproveModel
        isShowing={isShowing}
        hide={toggle}
        user_email={user_email}
        //  user_name = {user_name}
        //  user_mobile = {user_mobile}

        campaignId={campaignId}
        station={station}
        getCampaignlist={callCurrentPage}
      />{" "}
      <RejectModel
        isRejectShowing={isRejectShowing}
        hide={rejectToggle}
        user_email={user_email}
        //vj
        //  user_name = {user_name}
        //  user_mobile = {user_mobile}

        campaignId={campaignId}
        station={station}
        getCampaignlist={callCurrentPage}
      />{" "}
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        {/* <div className="navbar-header dashboard-header clearfix">
          <div className="logo-dashboard">
            <a id="logo">
              <img className="logo-trans" src="/assets/images/new_logo.png" />
            </a>{" "}
            <span> Welcome: {adminInfo.email} </span>{" "}
            <span>
              Last Login @{" "}
              {moment(adminInfo.lastLogin).format("DD/MM/YYYY hh:mm A")}{" "}
            </span>{" "}
          </div>{" "}
          <div
            className="user-profile pull-right"
            tabIndex={0}
            onClick={() => {
              localStorage.removeItem("adminInfo");
              window.location.href = "/admin/login";
            }}
          >
            <a>
              <span>
                LOGOUT{" "}
                <span className="log_img">
                  <img src="/assets/images/ic_logout.png" />
                </span>{" "}
              </span>{" "}
            </a>{" "}
          </div>{" "}
        </div>{" "} */}
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>{" "}
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Campaign Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                  Campaign List{" "}
                </span>{" "}
              </div>
              <div className="print_btn">
                <button onClick={showHideExcelPopup}> Download Excel </button>{" "}
              </div>{" "}
            </div>
            <form id="search-campaign-form" action="">
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td rowSpan="2">
                      <div
                        className={
                          !searchCampaignId && campaigns.length === 0
                            ? "search_camp none search-container"
                            : "search_camp search_list search-container"
                        }
                      >
                        {/*<input type="text" placeholder="Campaignname search" onChange={getSearch}/>*/}{" "}
                        <input
                          type="text"
                          placeholder="Enter campaign Id"
                          onChange={ (e)=> { handleSearchCampaignId(e.target.value)}}
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="startDate">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          placeholderText=" Start Date"
                          maxDate={endDate}
                          isClearable
                        />
                      </div>{" "}
                    </td>{" "}
                    <td>
                      <div className="endDate">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          minDate={startDate}
                          placeholderText=" End date"
                          isClearable
                        />
                      </div>{" "}
                    </td>{" "}
                    <td>
                      <div className="drop">
                        <select
                          className="packageType drop-down-icon"
                          onChange={(event) =>
                            handlePackagetype(event.target.value)
                          }
                        >
                          <option value=""> Choose Package Type </option>{" "}
                          <option value="Frequency Based">
                            {" "}
                            Frequency Based{" "}
                          </option>{" "}
                          <option value="Day Based"> Day Based </option>{" "}
                          <option value="Rotation Based"> Rotation Based </option>{" "}
                          <option value="Month Based">
                            {" "}
                            Payment Completed{" "}
                          </option>{" "}
                          <option value="Production Sale">
                            {" "}
                            Production Sale{" "}
                          </option>{" "}
                        </select>{" "}
                      </div>{" "}
                    </td>
                    {localStorage.getItem("adminRole") &&
                      localStorage.getItem("adminRole") === "campaignAdmin" && (
                        <td>
                          <div className="drop">
                            <select
                              className="packageType drop-down-icon"
                              onChange={(event) =>
                                handleCampaignstatustype(event.target.value)
                              }
                            >
                              <option value=""> Campaign status </option>{" "}
                              <option value="Audio Approved">
                                Audio Approved{" "}
                              </option>{" "}
                              <option value="RO Approved"> RO Approved </option>{" "}
                              <option value="New Campaign">
                                New Campaign{" "}
                              </option>{" "}
                              <option value="Payment Pending">
                                Payment Pending{" "}
                              </option>{" "}
                              <option value="Payment Completed">
                                {" "}
                                Payment Completed{" "}
                              </option>{" "}
                            </select>{" "}
                          </div>{" "}
                        </td>
                      )}
                    {localStorage.getItem("adminRole") &&
                      localStorage.getItem("adminRole") === "trafficAdmin" && (
                        <td>
                          <div className="drop">
                            <select
                              className="packageType drop-down-icon"
                              onChange={(event) =>
                                handleRostatustype(event.target.value)
                              }
                            >
                              <option value=""> Ro status </option>{" "}
                              <option value="Day Based"> RO Approved </option>{" "}
                              <option value="Month Based"> RO Booked </option>{" "}
                            </select>{" "}
                          </div>{" "}
                        </td>
                      )}
                    {localStorage.getItem("adminRole") &&
                      localStorage.getItem("adminRole") !== "stationAdmin" && (
                        <td>
                          <div className="status-input search_camp search_list">
                            <select
                              className="packageType drop-down-icon"
                              onChange={(e) => {
                                handleClusterDataNameType(e.target.value);
                              }}
                            >
                              <option value="" disabled selected hidden>
                                {" "}
                                Choose ClusterName{" "}
                              </option>{" "}
                              {clusterdata.map((cluster) => (
                                <option> {cluster} </option>
                              ))}{" "}
                            </select>{" "}
                          </div>{" "}
                        </td>
                      )}
                    <td>
                      {" "}
                      <div className="print_btn">
                        {" "}
                        {/***  <button type="button" onClick={clearSearch}>Clear</button>*/}{" "}
                        <button type="reset" onClick={clearSearch}>
                          Clear{" "}
                        </button>{" "}
                      </div>{" "}
                    </td>{" "}
                  </tr>
                  <tr>
                    <td>
                      <div
                        className={
                          !searchName && campaigns.length === 0
                            ? "search_camp none search-container"
                            : "search_camp search_list search-container"
                        }
                      >
                        {/*<input type="text" placeholder="Campaignname search" onChange={getSearch}/>*/}{" "}
                        <input
                          type="text"
                          ref={campaignName}
                          placeholder="Enter campaign name"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div
                        className={
                          !email && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={userEmail}
                          placeholder="Email"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div
                        className={
                          !station && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={searchStation}
                          placeholder="Station Name"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div
                        className={
                          !razorpay && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={searchRazorpay}
                          placeholder="Razorpay ID"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="print_btn">
                        <button type="button" onClick={callSearch}>
                          Search{" "}
                        </button>{" "}
                      </div>{" "}
                    </td>{" "}
                  </tr>{" "}
                </tbody>{" "}
              </table>{" "}
            </form>{" "}
            <div
              className={
                campaigns.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th> Campaign Name </th> <th> Created Date </th>{" "}
                    <th> Start Date </th> <th> Station </th>{" "}
                    <th> Package Type </th> <th> Payment Status </th>{" "}
                    <th> Status </th> <th className="txt-cntr"> Actions </th>{" "}
                    <th> CampaignId </th> <th> User Email </th> <th> Price </th>{" "}
                    <th> payId </th> <th> payId_1 </th> <th> Sales User Id </th>
                    {/* <th>Audio</th> */}{" "}
                  </tr>{" "}
                </thead>{" "}
                <tbody>
                  {" "}
                  {campaigns.map((c, i) => (
                    <tr key={i}>
                      <td> {c.name} </td>{" "}
                      <td> {moment(c.createdAt).format("DD/MM/YYYY")} </td>{" "}
                      <td> {moment(c.startDate).format("DD/MM/YYYY")} </td>{" "}
                      <td> {c.station.includes(",") ? (
                              <a
                                onClick={(e) => {
                                  handleshowstationlist(true);
                                  handleCurrentStations(c.station.split(","));
                                }}
                              >
                                Multiple ({c.station.split(",").length})
                              </a>
                            ) : (
                              c.station
                            )} </td>{" "}
                      <td> {c.type} </td>{" "}
                      <td>
                        {" "}
                        {c.pendingAmount && c.pendingAmount > 0
                          ? "Payment Pending"
                          : "Payment Completed"}{" "}
                      </td>
                      <td>
                        {" "}
                        {!c.payId_1 && c.paymentDetails.length == 2 && localStorage.getItem("adminRole") &&
                          (localStorage.getItem("adminRole") ===
                            "financeAdmin" || localStorage.getItem("adminRole") ===
                            "campaignAdmin" ||
                            localStorage.getItem("adminRole") === "admin")  && <select
                              onChange={(event) => linkpayment(event, c)}
                              value={c.status === "Pending" ? "New" : c.status}
                              className="status_select new"
                              disabled={c.status === "RO Approved"}
                            >
                              {paymentArr.map((audioState, index) => (
                                <option key={index}> {audioState} </option>
                              ))}{" "}
                            </select>}
                            {!c.payId_1 && c.paymentDetails.length == 2 && localStorage.getItem("adminRole") &&
                          (localStorage.getItem("adminRole") !==
                            "financeAdmin" || localStorage.getItem("adminRole") !==
                            "campaignAdmin" ||
                            localStorage.getItem("adminRole") !== "admin")  && "Verification Pending"}
                        {localStorage.getItem("adminRole") &&
                          (localStorage.getItem("adminRole") ===
                            "campaignAdmin" ||
                            localStorage.getItem("adminRole") === "admin") &&
                          c.status != "RO Booked" &&
                          c.status != "Invoice Booked" &&
                          c.status != "Production Sale" &&
                          c.status != "On-Hold" && (c.payId_1 || (!c.payId_1 && c.paymentDetails.length === 1) || c.name.trim().endsWith("_Audio")) && (
                            <select
                              onChange={(event) => setAudioStatus(event, c)}
                              value={c.status === "Pending" ? "New" : c.status}
                              className={
                                c.status == "Pending"
                                  ? "status_select new"
                                  : c.status == "RO Booked" ||
                                    c.status == "Invoice Booked"
                                  ? "status-select ro_booked"
                                  : c.status === "RO Approved"
                                  ? "status_select audio_approved"
                                  : "status_select ro_approved"
                              }
                              disabled={c.status === "RO Approved"}
                            >
                              {audioStateArr.map((audioState, index) => (
                                <option key={index}> {audioState} </option>
                              ))}{" "}
                            </select>
                          )}
                        {localStorage.getItem("adminRole") &&
                          (localStorage.getItem("adminRole") ===
                            "campaignAdmin" ||
                            localStorage.getItem("adminRole") === "admin") &&
                          (c.status === "RO Booked" ||
                            c.status === "Invoice Booked" ||
                            c.status === "Production Sale" ||
                            c.status === "On-Hold")&& (c.payId_1 || (!c.payId_1 && c.paymentDetails.length === 1) || c.name.trim().endsWith("_Audio")) && (
                            <span
                              className={
                                c.status == "On-Hold"
                                  ? "status-select hold"
                                  : c.status == "RO Booked" ||
                                    c.status == "Invoice Booked"
                                  ? "status-select ro_booked"
                                  : "status-select ro_approved"
                              }
                            >
                              {" "}
                              {c.status}{" "}
                            </span>
                          )}
                        {localStorage.getItem("adminRole") &&
                          (((
                            localStorage.getItem("adminRole") ===
                              "auditAdmin") &&
                            !c.sallerId) ||
                            localStorage.getItem("adminRole") ===
                              "clusterAdmin")&& (c.payId_1 || (!c.payId_1 && c.paymentDetails.length === 1) || c.name.trim().endsWith("_Audio")) && (
                            <span
                              className={
                                c.status == "Pending"
                                  ? "status-select new"
                                  : c.status == "On-Hold"
                                  ? "status-select hold"
                                  : c.status == "RO Booked" ||
                                    c.status == "Invoice Booked"
                                  ? "status-select ro_booked"
                                  : c.status === "RO Approved"
                                  ? "status-select audio_approved"
                                  : "status-select ro_approved"
                              }
                            >
                              {" "}
                              {c.status === "Pending" ? "New" : c.status}{" "}
                            </span>
                          )}
                          {localStorage.getItem("adminRole") && localStorage.getItem("adminRole") ===
                              "salesUser" &&  c.status !== "Pending" && c.status }
                        {localStorage.getItem("adminRole") &&
                          (localStorage.getItem("adminRole") ===
                            "stationAdmin" ||
                            (localStorage.getItem("adminRole") ===
                              "salesUser") ||
                            (localStorage.getItem("adminRole") ===
                              "auditAdmin" &&
                              c.sallerId &&
                              adminInfo.email.trim() === c.sallerId.trim())) &&
                          c.status &&
                          c.status === "Pending" && (c.payId_1 || (!c.payId_1 && c.paymentDetails.length === 1) || c.name.trim().endsWith("_Audio"))&& (
                            <select
                              onChange={(event) => setAudioStatus(event, c)}
                              value={c.status === "Pending" ? "New" : c.status}
                              className="status_select new"
                              disabled={c.status === "RO Approved"}
                            >
                              {audioStateArray.map((audioState, index) => (
                                <option key={index}> {audioState} </option>
                              ))}{" "}
                            </select>
                          )}
                        {localStorage.getItem("adminRole") &&
                          (localStorage.getItem("adminRole") ===
                            "stationAdmin" ||
                            (localStorage.getItem("adminRole") ===
                              "auditAdmin" &&
                              c.sallerId &&
                              adminInfo.email.trim() === c.sallerId.trim())) &&
                          c.status != "Pending" && (c.payId_1 || (!c.payId_1 && c.paymentDetails.length === 1) || c.name.trim().endsWith("_Audio"))&& (
                            <span
                              className={
                                c.status == "Pending"
                                  ? "status_select new"
                                  : c.status === "On-Hold"
                                  ? "status-select hold"
                                  : c.status === "RO Booked" ||
                                    c.status === "Invoice Booked"
                                  ? "status-select ro_booked"
                                  : c.status === "RO Approved"
                                  ? "status_select audio_approved"
                                  : "status-select ro_approved"
                              }
                            >
                              {" "}
                              {c.status}{" "}
                            </span>
                          )}
                        {localStorage.getItem("adminRole") &&
                          localStorage.getItem("adminRole") ===
                            "trafficAdmin" &&
                          c.status === "RO Approved" && (c.payId_1 || (!c.payId_1 && c.paymentDetails.length === 1) || c.name.trim().endsWith("_Audio"))&& (
                            <select
                              onChange={(event) => setRoStatus(event, c)}
                              value={c.status}
                              className={
                                c.status === "RO Approved"
                                  ? "status_select audio_approved"
                                  : "status_select ro_approved"
                              }
                            >
                              {roStateArray.map((audioState, index) => (
                                <option key={index}> {audioState} </option>
                              ))}{" "}
                            </select>
                          )}
                        {localStorage.getItem("adminRole") &&
                          localStorage.getItem("adminRole") ===
                            "trafficAdmin" &&
                          c.status === "Production Sale"&& (c.payId_1 || (!c.payId_1 && c.paymentDetails.length === 1) || c.name.trim().endsWith("_Audio")) && (
                            <select
                              onChange={(event) => setRoStatus(event, c)}
                              value={c.status}
                              className={
                                c.status === "Production Sale"
                                  ? "status_select audio_approved"
                                  : "status_select ro_approved"
                              }
                            >
                              {productionStateArray.map((audioState, index) => (
                                <option key={index}> {audioState} </option>
                              ))}{" "}
                            </select>
                          )}
                        {localStorage.getItem("adminRole") &&
                          localStorage.getItem("adminRole") ===
                            "trafficAdmin"&& (c.payId_1 || (!c.payId_1 && c.paymentDetails.length === 1) || c.name.trim().endsWith("_Audio")) &&
                          (c.status === "RO Booked" ||
                            c.status === "Invoice Booked") && (
                            <span className="status-select ro_booked">
                              {" "}
                              {c.status}{" "}
                            </span>
                          )}
                        {localStorage.getItem("adminRole") &&
                          localStorage.getItem("adminRole") ===
                            "financeAdmin"&& (c.payId_1 || (!c.payId_1 && c.paymentDetails.length === 1) ) && (
                            <span className="status-select ro_approved">
                              {" "}
                              {c.status}{" "}
                            </span>
                          )}
                      </td>{" "}
                      <td className="txt-cntr">
                        <a>
                          <span className="tooltip-reject view-tooltip">
                            <img
                              src="/assets/images/eye.png"
                              className="reject-approved-img reject-png"
                              onClick={() => {
                                props.onSubmit();
                                props.getCampaignDetails(c);
                              }}
                            />
                            <span>View</span>
                          </span>
                        </a>

                        {c.status == "Pending" &&
                          adminInfo.role !== "salesUser" &&
                          adminInfo.role !== "auditAdmin" &&
                          adminInfo.role !== "clusterAdmin" &&
                          adminInfo.role !== "financeAdmin" &&
                          c.bigFmAudio == "false" && (
                            <a>
                              <span className="tooltip-reject">
                                <img
                                  src="/assets/images/reject.png"
                                  className="reject-approved-img reject-png"
                                  onClick={openRejectPopup.bind(this, c)}
                                />
                                <span>Reject</span>
                              </span>
                            </a>
                          )}
                        {c.status == "Pending" &&
                          (adminInfo.role === "salesUser" ||
                            adminInfo.role === "auditAdmin") &&
                          c.sallerId &&
                          c.bigFmAudio == "false" && (
                            <a>
                              <span className="tooltip-reject">
                                <img
                                  src="/assets/images/reject.png"
                                  className="reject-approved-img reject-png"
                                  onClick={openRejectPopup.bind(this, c)}
                                />
                                <span>Reject</span>
                              </span>
                            </a>
                          )}
                      </td>
                      <td> {c._id} </td> <td> {c.userEmail} </td>{" "}
                      <td> {c.totalCost} </td>{" "}
                      {/* <td className={c.status === "Pending" ? "tbl_bg_new" : c.status === 'Audio Approved' ? "tbl_bg_audio_approved" : c.status === 'RO Approved' ? 'tbl_bg_audio_approved' : c.status === 'RO Booked' ? 'tbl_bg_green' : ''}> */}
                      <td> {c.payId} </td> <td> {c.payId_1} </td>
                      <td> {c.sallerId} </td>{" "}
                    </tr>
                  ))}{" "}
                </tbody>{" "}
              </table>{" "}
              <div className="paginationTable" />{" "}
              {(skip > 0 || count > 10) && (
                <Pagination getAllData={getCampaignlist} totalRecords={count} />
              )}{" "}
            </div>{" "}
            {campaigns.length === 0 ? <NoData /> : null}{" "}
          </section>{" "}
        </div>{" "}
      </div>{" "}
      {/* {campaigns.length ===0 && (!searchName && !searchId)?
                      <NoData /> : null} */}{" "}
      {showExcelPopup && <ExcelPopup hideExcelPopup={showHideExcelPopup} />}
      {showUploadContract && (
        <UploadContract
          hideUploadContract={showHideUploadContract}
          campaignId={campaignId}
          fileType={fileType}
          status={status}
          client={selectedCustomerDetails}
          statusStages={statusStages}
          uploadContact={uploadContact}
          updateObj={updateObj}
          campaign={currentCampaign}
          updateCampaign={props.updateCampaign}
          endDate={customendDate}
        />
      )}
      {showTrafficOrder && (
        <EditToOrder
          hideUploadContract={showHideTrafficOrder}
          showChangeEndDate={showChangeEndDate}
          campaignId={campaignId}
          fileType={fileType}
          status={status}
          client={selectedCustomerDetails}
          statusStages={statusStages}
          uploadContact={uploadContact}
          updateObj={updateObj}
          campaign={currentCampaign}
          updateCampaign={props.updateCampaign}
          endDate={customendDate}
          getCampaignlist={callCurrentPage}
        />
      )}
      {showconfirmpaymentcapture && (
        <CommonModelImpl
          headerMsg={"Payment Capture Confirmation"}
          msg={msg}
          okButtonShow={true}
          okButtonText={"Captured"}
          okAction={setStatusAfterPaymentConfirmation}
          cancelButtonShow={true}
          cancelButtonText={"Not Captured"}
          cancelAction={showHidePaymentConfirmationPopup}
        />
      )}
        {updatePaymentId && (
        <LinkPayment
          campaignId={campaignId}
          closeAction={removePaymentId}
          okButtonText="Proceed to Payment"
          okAction={handlePaymentId}
          cancelButtonShow={true}
          cancelButtonText="Cancel"
          callCurrentPage={callCurrentPage}
        />
      )}
      {showCustomEndDatePopup && (
        <ChangeEndDate
          okButtonShow={true}
          closeAction={closecustomenddatepopup}
          okButtonText="Generate TO"
          okAction={generateTrafficOrder}
          cancelButtonShow={true}
          cancelButtonText="Cancel"
          handleDate={handleCustomEndDate}
          startDate={customendDate}
          minStartDate={moment(currentCampaign.startDate).add(currentCampaign.days -1,  'days').valueOf()}
          msg="Please Select a End Date for this Campaign"
        />
      )}
       {showstationlist && (
                <ViewStationsModal
                  stations={currentStations}
                  closeAction={hideshowstations}
                />
              )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/index.js